import AppList from './AppList';

export default {
    list: 	AppList
};
